// Class: starling.display.Sprite

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_display_DisplayObjectContainer() {return require("./../../starling/display/DisplayObjectContainer");}

// Constructor

var Sprite = function() {
	(starling_display_DisplayObjectContainer().default).call(this);
}

// Meta

Sprite.__name__ = "starling.display.Sprite";
Sprite.__isInterface__ = false;
Sprite.__super__ = (starling_display_DisplayObjectContainer().default);
Sprite.prototype = $extend((starling_display_DisplayObjectContainer().default).prototype, {
	
});
Sprite.prototype.__class__ = Sprite.prototype.constructor = $hxClasses["starling.display.Sprite"] = Sprite;

// Init



// Statics




// Export

exports.default = Sprite;